export const BIDDING_STRATEGIES = {
    MAXIMIZE_CONVERSIONS: "Maximize Conversions",
    MAXIMIZE_LINK_CLICKS: "Maximize Link Clicks",
    MAXIMIZE_DAILY_UNIQUE_REACH: "Maximize Daily Unique Reach",
    MAXIMIZE_IMPRESSIONS: "Maximize Impressions",
};
